export default class UpdatePriceTable extends HTMLTableRowElement {
    constructor() {
        super();

        this.initElements();
    }

    initElements() {
        this.price = this.dataset.price;
        this.quantitySelector = this.querySelector('input[name="quantity"]');
        this.priceSelector = this.querySelector('.dynamicPrice');
    }

    connectedCallback() {
        this.quantitySelector.addEventListener('change', (e) => {
            e.preventDefault();

            const quantity = this.quantitySelector.value;
            const price = this.price * quantity;

            this.priceSelector.innerHTML = price.toFixed(2).replace(/\./, ',') + ' €';
        });
    }
}
